import clsx from 'clsx';
import Link from 'next/link';
import { ArrowIcon } from 'src/components/shared/elements/icons/ArrowIcon';
import styles from './index.module.scss';

type Props = {
  text: string;
  testDataId?: string;
  href?: string;
  onClick?: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  outline?: boolean;
  disabled?: boolean;
  isBlack?: boolean;
  isBlueButton?: boolean;
  isYellowButton?: boolean;
  isGray?: boolean;
  isActive?: boolean;
  target?: string;
  rel?: string;
  externalLink?: string;
  width?: number | 'max-content' | 'auto' | 'w-full';
  minWidth?: number;
  height?: number | 'h-full';
  minHeight?: number;
  fontSize?: number;
  paddingX?: number;
  hasArrowRight?: boolean;
  borderRadius?: number;
};

export const BaseButton: React.FC<Props> = ({
  text,
  testDataId,
  href,
  onClick,
  outline = false,
  disabled = false,
  isBlack = false,
  isBlueButton = false,
  isYellowButton = false,
  isGray = false,
  isActive = false,
  target,
  rel,
  externalLink,
  width = 240,
  height = 40,
  fontSize = 16,
  minWidth,
  minHeight,
  paddingX,
  borderRadius = 20,
  hasArrowRight = false
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      if (!externalLink && !href) {
        e.preventDefault();
      }
      onClick();
    }
  };
  return (
    <Link href={href ?? ''}>
      <a
        href={externalLink ?? ''}
        target={target ?? ''}
        rel={rel ?? ''}
        role="button"
        data-testid={testDataId}
        onClick={handleClick}
        className={clsx(
          styles.container,
          outline && styles.outline,
          disabled && styles.disabled,
          outline && isBlack && styles.black,
          isBlueButton && styles.blueButton,
          isYellowButton && styles.yellow,
          outline && isGray && styles.gray,
          isActive && styles.isActive
        )}
        style={{
          width: typeof width === 'number' ? `${width}px` : width,
          height: typeof height === 'number' ? `${height}px` : height,
          fontSize: `${fontSize}px`,
          padding: paddingX && `0 ${paddingX}px`,
          borderRadius: `${borderRadius}px`,
          minWidth: minWidth && `${minWidth}px`,
          minHeight: minHeight && `${minHeight}px`
        }}
      >
        <span className={styles.text}>{text}</span>
        {hasArrowRight && <ArrowIcon fillColor="#2F353E" className={styles.arrowRight} />}
      </a>
    </Link>
  );
};
